export default __webpack_public_path__ + "static/media/el_star-alt.f058a147.svg";